<template>
  <div :class="['template-data-grid-filter', {'has-body': !!$scopedSlots.default}]">
    <div class="header">
      <el-form size="mini"
               class="filter-form">
        <el-form-item v-for="filter in filters"
                      :key="filter.field"
                      :label="filter.label"
                      class="filter-item">
          <template v-if="filter.dataType === 'CASCADER'">
            <DataGridMetaCascader v-model="filterParam[filter.field]"
                                  :clearable="filter.allowBlank"
                                  :options="filter.options"
                                  :placeholder="filter.placeholder"></DataGridMetaCascader>
          </template>
          <template v-else>
            <DataGridMetaSelect v-model="filterParam[filter.field]"
                                :clearable="filter.allowBlank"
                                :options="filter.options"
                                :placeholder="filter.placeholder"></DataGridMetaSelect>
          </template>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="$scopedSlots.default"
         class="body">
      <div class="body-wrap">
        <template v-if="filterKey">
          <slot :filter-key="filterKey"
                :filter-param="filterParam"></slot>
        </template>
        <template v-else>
          <Hint>
            <div>{{checkFilterMsg || '请先选择筛选条件'}}</div>
          </Hint>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import DataGridMetaSelect from '../../elements/grid/DataGridMetaSelect'
import DataGridMetaCascader from '../../elements/grid/DataGridMetaCascader'
import TemplateDataGrid from '../TemplateDataGrid'
import Hint from '../../elements/Hint'
export default {
  name: 'TemplateDataGridFilter',
  components: {
    DataGridMetaSelect,
    DataGridMetaCascader,
    TemplateDataGrid,
    Hint
  },
  props: {
    filters: {
      type: Array,
      required: true
    },
    useFilterParam: Object
  },
  data () {
    return {
      filterParam: {}
    }
  },
  computed: {
    isAllFiltered () {
      return this.filters.every(filter => {
        if (!filter.allowBlank) {
          return !!this.filterParam[filter.field]
        }
        return true
      })
    },
    filterKey () {
      if (this.isAllFiltered) {
        return Object.entries(this.filterParam).map(([k, v]) => {
          return `${k}=${v}`
        }).join('&')
      }
    },
    checkFilterMsg () {
      const getFilter = this.filters.find(filter => {
        if (!filter.allowBlank) {
          return !this.filterParam[filter.field]
        }
      })
      if (getFilter) {
        return `请先选择${getFilter.label}`
      }
    }
  },
  methods: {
    initFilterParam () {
      const filters = this.filters || []
      filters.forEach(filter => {
        const {field, defaultValue = ''} = filter
        const fieldValue = this.filterParam[field]
        if (typeof fieldValue === 'undefined') {
          this.$set(this.filterParam, field, defaultValue)
        }
      })
    }
  },
  watch: {
    filters: {
      handler () {
        this.initFilterParam()
      },
      immediate: true
    },
    useFilterParam: {
      handler (val) {
        if (val) {
          Object.keys(val).forEach(key => {
            this.$set(this.filterParam, key, val[key])
          })
        }
      },
      immediate: true
    },
    filterParam: {
      handler () {
        this.$nextTick(() => {
          this.$emit('filterKeyChange', {
            filterKey: this.filterKey,
            filterParam: this.filterParam
          })
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.template-data-grid-filter {
  &.has-body {
    height: 100%;
    display: flex;
    flex-direction: column;
    &>.header {
      flex: none;
      background-color: #fff;
      padding: 10px 15px;
    }
    &>.body {
      flex: auto;
      position: relative;
      border-top: 1px solid #EBEEF5;
      &>.body-wrap {
        position: absolute;
        inset: 0;
      }
    }
  }
  &>.header {
    flex: none;
    .filter-form {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .filter-item {
        margin-right: 15px;
        display: flex;
        align-items: center;
      }
    }
    .el-form-item {
      margin-bottom: 0;
      .el-form-item__label {
        font-size: 12px;
      }
      .el-form-item__content {
        .el-select,
        .el-cascader {
          width: 200px!important;
        }
      }
    }
  }
}
</style>
